// Populates the shared "Request a plant" page with the plant that was clicked
// in the gallery. The gallery tile links carry the plant's data as URL params
// (?plant=...&img=...&desc=...). Falls back to the section defaults on a direct visit.
(function () {
  const params = new URLSearchParams(window.location.search);
  const plant = (params.get('plant') || '').trim();
  const img = (params.get('img') || '').trim();
  const desc = (params.get('desc') || '').trim();

  if (plant) {
    document.querySelectorAll('[data-plant-title]').forEach((el) => {
      el.textContent = plant;
    });
    document.title = plant;

    // Pre-fill the request message so the merchant knows which plant.
    document.querySelectorAll('[data-plant-message]').forEach((el) => {
      if (!el.value) el.value = "I'm interested in: " + plant;
    });
  }

  const vsrc = (params.get('vsrc') || '').trim();
  const vtype = (params.get('vtype') || '').trim();
  const vid = (params.get('vid') || '').trim();

  function buildMedia(el) {
    // Uploaded (Shopify-hosted) video.
    if (vsrc) {
      const video = document.createElement('video');
      video.className = 'reqp__img';
      video.src = vsrc;
      video.controls = true;
      video.autoplay = true;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      if (img) video.poster = img;
      el.replaceChildren(video);
      return;
    }
    // YouTube / Vimeo embed.
    if (vid && (vtype === 'youtube' || vtype === 'vimeo')) {
      const iframe = document.createElement('iframe');
      iframe.className = 'reqp__video-embed';
      iframe.src =
        vtype === 'youtube'
          ? 'https://www.youtube.com/embed/' + encodeURIComponent(vid) + '?rel=0'
          : 'https://player.vimeo.com/video/' + encodeURIComponent(vid);
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      el.replaceChildren(iframe);
      return;
    }
    // Plain image.
    if (img) {
      const image = document.createElement('img');
      image.className = 'reqp__img';
      image.src = img; // assigning .src never executes script
      image.alt = plant || '';
      image.loading = 'eager';
      el.replaceChildren(image);
    }
  }

  if (vsrc || vid || img) {
    document.querySelectorAll('[data-plant-media]').forEach(buildMedia);
  }

  if (desc) {
    document.querySelectorAll('[data-plant-desc]').forEach((el) => {
      el.textContent = desc;
      el.hidden = false;
    });
  }

  // Breeding details list (Genus / Species / Hybrid / Seed / Pollen parent).
  const detailRows = [
    ['Genus', params.get('genus')],
    ['Species', params.get('species')],
    ['Hybrid', params.get('hybrid')],
    ['Seed parent', params.get('seed')],
    ['Pollen parent', params.get('pollen')],
  ].filter(([, v]) => v && v.trim());

  if (detailRows.length) {
    document.querySelectorAll('[data-plant-details]').forEach((dl) => {
      dl.replaceChildren();
      detailRows.forEach(([label, value]) => {
        const row = document.createElement('div');
        row.className = 'reqp__detail';
        const dt = document.createElement('dt');
        dt.textContent = label;
        const dd = document.createElement('dd');
        dd.textContent = value.trim();
        row.append(dt, dd);
        dl.append(row);
      });
      dl.hidden = false;
    });
  }
})();
